var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-secondary d-flex font-weight-bold filter-header"},[_c('h5',{staticClass:"p-0 m-0"},[_vm._v(_vm._s(_vm.headline))]),_c('div',{staticClass:"ml-auto"},[_c('small',{staticClass:"link",on:{"click":function($event){return _vm.resetFilter()}}},[_vm._v(_vm._s(_vm.reset))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }